import { IFormErrors } from '@interfaces/IFormsErrors';
import { IGroup, IGroups, IUserAccessToGroup } from '@interfaces/IGroup';
import { Action } from '@ngrx/store';

export enum EGroupsViewActions {
  GetGroupDetailRequest = '[Groups] Get Group Detail Request',
  GetGroupDetailSuccess = '[Groups] Get Group Detail Success',
  GetGroupDetailFailure = '[Groups] Get Group Detail Failure',
  ClearGroupDetail = '[Groups] Clear Group Detail',

  GetGroupsRequest = '[Groups] Get Groups Request',
  GetGroupsSuccess = '[Groups] Get Groups Success',
  GetGroupsFailure = '[Groups] Get Groups Failure',
  ClearGroups = '[Groups] Clear Groups',

  GetStudentsTransfersGroupsRequest = '[Groups] Get Students Transfers Groups Request',
  GetStudentsTransfersGroupsSuccess = '[Groups] Get Students Transfers Groups Success',
  GetStudentsTransfersGroupsFailure = '[Groups] Get Students Transfers Groups Failure',
  ClearStudentsTransfersGroups = '[Groups] Clear Students Transfers Groups',

  GetAllCourseGroupsRequest = '[Groups] Get All Course Groups Request',
  GetAllCourseGroupsSuccess = '[Groups] Get All Course Groups Success',
  GetAllCourseGroupsFailure = '[Groups] Get All Course Groups Failure',

  GetActiveCourseGroupsRequest = '[Groups] Get Active Course Groups Request',
  GetActiveCourseGroupsSuccess = '[Groups] Get Active Course Groups Success',
  GetActiveCourseGroupsFailure = '[Groups] Get Active Course Groups Failure',

  GetInactiveCourseGroupsRequest = '[Groups] Get Inactive Course Groups Request',
  GetInactiveCourseGroupsSuccess = '[Groups] Get Inactive Course Groups Success',
  GetInactiveCourseGroupsFailure = '[Groups] Get Inactive Course Groups Failure',

  ClearCourseGroups = '[Groups] Clear Course Groups',

  GetStudentAccessRequest = '[Groups] Get Student Access Request',
  GetStudentAccessSuccess = '[Groups] Get Student Access Success',
  GetStudentAccessFailure = '[Groups] Get Student Access Failure',
  ClearGetStudentAccess = '[Groups] Clear Get Student Access',
}

export class GetGroupDetailRequest implements Action {
  public readonly type = EGroupsViewActions.GetGroupDetailRequest;

  constructor(public id: number) {}
}

export class GetGroupDetailSuccess implements Action {
  public readonly type = EGroupsViewActions.GetGroupDetailSuccess;

  constructor(public payload: IGroup) {}
}

export class GetGroupDetailFailure implements Action {
  public readonly type = EGroupsViewActions.GetGroupDetailFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGroupDetail implements Action {
  public readonly type = EGroupsViewActions.ClearGroupDetail;
}

export class GetGroupsRequest implements Action {
  public readonly type = EGroupsViewActions.GetGroupsRequest;

  constructor(public qParams?: { [key: string]: string }) {}
}

export class GetGroupsSuccess implements Action {
  public readonly type = EGroupsViewActions.GetGroupsSuccess;

  constructor(public groups: IGroups) {}
}

export class GetGroupsFailure implements Action {
  public readonly type = EGroupsViewActions.GetGroupsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGroups implements Action {
  public readonly type = EGroupsViewActions.ClearGroups;
}

export class GetStudentsTransfersGroupsRequest implements Action {
  public readonly type = EGroupsViewActions.GetStudentsTransfersGroupsRequest;

  constructor(public id: number) {}
}

export class GetStudentsTransfersGroupsSuccess implements Action {
  public readonly type = EGroupsViewActions.GetStudentsTransfersGroupsSuccess;

  constructor(public groups: IGroups) {}
}

export class GetStudentsTransfersGroupsFailure implements Action {
  public readonly type = EGroupsViewActions.GetStudentsTransfersGroupsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearStudentsTransfersGroups implements Action {
  public readonly type = EGroupsViewActions.ClearStudentsTransfersGroups;
}

export class GetActiveCourseGroupsRequest implements Action {
  public readonly type = EGroupsViewActions.GetActiveCourseGroupsRequest;

  constructor(
    public id: number,
    public qParams?: { [key: string]: string | boolean }
  ) {}
}

export class GetActiveCourseGroupsSuccess implements Action {
  public readonly type = EGroupsViewActions.GetActiveCourseGroupsSuccess;

  constructor(public groups: IGroups) {}
}

export class GetActiveCourseGroupsFailure implements Action {
  public readonly type = EGroupsViewActions.GetActiveCourseGroupsFailure;

  constructor(public error: IFormErrors) {}
}

export class GetAllCourseGroupsRequest implements Action {
  public readonly type = EGroupsViewActions.GetAllCourseGroupsRequest;

  constructor(public id: number) {}
}

export class GetAllCourseGroupsSuccess implements Action {
  public readonly type = EGroupsViewActions.GetAllCourseGroupsSuccess;

  constructor(public groups: IGroups) {}
}

export class GetAllCourseGroupsFailure implements Action {
  public readonly type = EGroupsViewActions.GetAllCourseGroupsFailure;

  constructor(public error: IFormErrors) {}
}

export class GetInactiveCourseGroupsRequest implements Action {
  public readonly type = EGroupsViewActions.GetInactiveCourseGroupsRequest;

  constructor(public id: number) {}
}

export class GetInactiveCourseGroupsSuccess implements Action {
  public readonly type = EGroupsViewActions.GetInactiveCourseGroupsSuccess;

  constructor(public groups: IGroups) {}
}

export class GetInactiveCourseGroupsFailure implements Action {
  public readonly type = EGroupsViewActions.GetInactiveCourseGroupsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearCourseGroups implements Action {
  public readonly type = EGroupsViewActions.ClearCourseGroups;
}

export class GetStudentAccessRequest implements Action {
  public readonly type = EGroupsViewActions.GetStudentAccessRequest;

  constructor(public groupId: number, public studentId: number) {}
}

export class GetStudentAccessSuccess implements Action {
  public readonly type = EGroupsViewActions.GetStudentAccessSuccess;

  constructor(public payload: IUserAccessToGroup) {}
}

export class GetStudentAccessFailure implements Action {
  public readonly type = EGroupsViewActions.GetStudentAccessFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetStudentAccess implements Action {
  public readonly type = EGroupsViewActions.ClearGetStudentAccess;
}

export type GroupsViewActions =
  | GetGroupDetailRequest
  | GetGroupDetailSuccess
  | GetGroupDetailFailure
  | GetGroupsRequest
  | GetGroupsSuccess
  | GetGroupsFailure
  | ClearGroups
  | ClearGroupDetail
  | GetStudentsTransfersGroupsRequest
  | GetStudentsTransfersGroupsSuccess
  | GetStudentsTransfersGroupsFailure
  | ClearStudentsTransfersGroups
  | GetActiveCourseGroupsRequest
  | GetActiveCourseGroupsSuccess
  | GetActiveCourseGroupsFailure
  | GetAllCourseGroupsRequest
  | GetAllCourseGroupsSuccess
  | GetAllCourseGroupsFailure
  | GetInactiveCourseGroupsRequest
  | GetInactiveCourseGroupsSuccess
  | GetInactiveCourseGroupsFailure
  | ClearCourseGroups
  | GetStudentAccessRequest
  | GetStudentAccessSuccess
  | GetStudentAccessFailure
  | ClearGetStudentAccess;
